export default __webpack_public_path__ + "static/video-152ca28b4c9be931ba69810af25e98e0.mp4";